import React from 'react';
import ReactDOM from 'react-dom/client';
import styles from "./index.module.css";
import App from './App';
import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

// ====== 🔒 Disable console logs on production domain ======
if (typeof window !== "undefined") {
  const hostname = window.location.hostname;

  const isProdDomain = hostname === "www.myzooshop.com.ua" || hostname === "myzooshop.com.ua";
  const isDevDomain =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "sports-store-theta.vercel.app";

  if (isProdDomain) {
    console.log = function () {};
    console.debug = function () {};
    console.info = function () {};
    console.warn = function () {};
    console.error = function () {};
  } else if (isDevDomain) {
    console.log("✅ Console logging ENABLED for dev/test domain:", hostname);
  } else {
    console.log("ℹ️ Unknown environment detected:", hostname);
  }
}
// ==========================================================

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginReact()]
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

axios.defaults.baseURL = process.env.REACT_APP_API_URL || "http://localhost:8080";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <div className={styles.body}>
        <App />
      </div>
    </ErrorBoundary>
  </React.StrictMode>
);
